import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import type { Theme } from '@mui/material';
import type { FC } from 'react';
import { defineColorFromTrendRating } from '../../utils';

interface IProps {
  type: 'preClean' | 'temp';
  rating: number | null;
  theme: Theme;
}

export const TrendIcon: FC<IProps> = ({ type, rating, theme }) => {
  const color = defineColorFromTrendRating(type, rating, theme);
  switch (rating) {
    case -1:
      return <TrendingDownIcon style={{ color, transform: 'scaleX(-1)' }} />;
    case 1:
      return <TrendingUpIcon style={{ color, transform: 'scaleX(-1)' }} />;
    case 0:
      return <TrendingFlatIcon style={{ color, transform: 'scaleX(-1)' }} />;
    default:
      return <TrendingFlatIcon style={{ color, transform: 'scaleX(-1)' }} />;
  }
};
